import ArticleDataViewModel from "../../view-model/ArticleDataViewModel.js";
import * as urlUtil from '../../util/UrlUtil'
import Axios from 'axios'

/**
 * 指定した記事情報を取得する.
 * @param articleId pathから取得した記事ID
 */
export function getArticleData(articleId) {
    return Axios.get(urlUtil.wordPressUtil.wordPressPostUrl(articleId)).then((result) => {
        return new ArticleDataViewModel(result.data)
    })
}